import { Camera } from '@hakimo-ui/hakimo/types';
import { SelectableCameraIcon } from '@hakimo-ui/hakimo/ui-elements';
import clsx from 'clsx';

interface Props {
  camera: Camera;
  checked: boolean;
  // Omitted for the drag preview, which is not interactive.
  onToggle?: (e: React.MouseEvent) => void;
}

const rowClassName =
  'flex w-full items-center gap-4 rounded-xl p-3 text-left outline-none';

const stateClassName = (checked: boolean) =>
  checked
    ? 'bg-onlight-bg-3/50 dark:bg-ondark-bg-3/50'
    : 'hover:bg-onlight-bg-3/50 dark:hover:bg-ondark-bg-3/50';

export function MultiCamCameraRow({ camera, checked, onToggle }: Props) {
  const content = (
    <>
      <SelectableCameraIcon
        checked={checked}
        className="text-onlight-text-1 dark:text-ondark-text-1 h-4 w-5 flex-none"
      />
      <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
        <span
          className="w-full truncate text-sm font-medium"
          title={camera.name}
        >
          {camera.name}
        </span>
        <span className="text-onlight-text-2 dark:text-ondark-text-2 w-full truncate text-xs">
          {camera.location?.name || '-'}
        </span>
      </div>
    </>
  );

  if (!onToggle) {
    return <div className={rowClassName}>{content}</div>;
  }
  return (
    <button
      type="button"
      onClick={onToggle}
      className={clsx(rowClassName, 'cursor-pointer', stateClassName(checked))}
    >
      {content}
    </button>
  );
}

export default MultiCamCameraRow;
